/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './viewing-schedule-tabs.stache';
import FeedService from 'scripts/services/base-feed-service';
import can from 'can';
import urlUtil from 'scripts/utils/url';
import utilDateTime from 'scripts/utils/date-time';
import _ from 'lodash';
import dayjs from 'dayjs';

const scheduleDatesUrl = window.globalSettings.feeds.schedule.scheduleDatesUrl;

Component.extend({
    tag: 'viewing-schedule-tabs',
    template,
    viewModel: {
        scheduleDate: '',
        getDay(date) {
            return date.split(',')[0];
        },
        onTabChange(event) {
            this.attr('scheduleDate', event.payload.value);
        }
    },
    events: {
        inserted() {
            new FeedService({feedUrl: scheduleDatesUrl, fromCache: false, autoUpdate: false})
                .on('data', (type, data) => {
                    if (data && data.tags && data.tags.length) {
                        this.viewModel.attr('days', data.tags);
                        this.viewModel.attr('scheduleDate', this.getScheduleDate(data.tags, data.defaultTagKey));
                    }
                })
                .on('error', (error) => {
                    console.error('Error fetching schedule dates', error);
                })
                .fetch();
        },
        getScheduleDate: function (dates, defaultDate) {
            let dateFormat = 'MM_DD_YYYY';
            let currentDate = dayjs(defaultDate, dateFormat).format(dateFormat);
            let currentDateSplitted = currentDate.split('_');
            let currentMonth = parseInt(currentDateSplitted[0]);
            let currentDay = parseInt(currentDateSplitted[1]);

            let isLive = _.find(dates, (day) => {
                if (day.key == currentDate) {
                    return true;
                }
                return;
            });

            if (isLive) {
                return isLive.key;
            } else {
                let firstUpcoming = _.find(dates, (day) => {
                    let upcomingDate = day.key.split('_').splice(0, 2);
                    let upcomingMonth = parseInt(upcomingDate[0]);
                    let upcomingDay = parseInt(upcomingDate[1]);

                    if (upcomingMonth == currentMonth) {
                        if (upcomingDay > currentDay) {
                            return true;
                        }
                    } else if (upcomingMonth > currentMonth) {
                        return true;
                    }
                });

                if (firstUpcoming) {
                    return firstUpcoming.key;
                } else {
                    let past;

                    _.each(dates, function (day) {
                        let pastDate = day.key.split('_').splice(0, 2);
                        let pastMonth = parseInt(pastDate[0]);
                        let pastDay = parseInt(pastDate[1]);

                        if (pastMonth == currentMonth || pastMonth < currentMonth) {
                            if (pastDay < currentDay) {
                                past = day;
                            }
                        }
                    });

                    if (past) {
                        return past.key;
                    }
                }
            }
            return defaultDate;
        }
    }
});
